import {
  Row,
  Col,
  Button,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Input,
  ModalFooter,
  Modal,
} from "reactstrap";
import { SwipeableDrawer } from "@mui/material";
import DataTable from "components/Core/DataTable";
import NotificationAlert from "react-notification-alert";
import Notify from "../../lib/Utils/Alert";

import Purchaser from "../../lib/Core/Backend/Controllers/Purchaser";
import { useRef, useEffect, useState, useMemo } from "react";
import HistorySKUDetails from "./HistorySKUDetails.jsx";

const ModalHistorySKU = (props) => {
  const { modalHistory, toggleModalHistory, token } = props;
  const purchaserCtl = useMemo(() => new Purchaser(token), [token]);
  const dataTableRef = useRef(null);
  const alert = useRef(null);
  const [dataTableData, setDataTableData] = useState({
    purchaseOrderResponse: [],
  });
  const [orderDetail, setOrderDetail] = useState([]);
  const [inputSearch, setInputSearch] = useState("");
  const [skuName, setSkuName] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const toggleDrawer = () => setOpenDrawer(!openDrawer);

  const header = [
    { title: "Date", data: "createdAt", sortable: true },
    { title: "Name", data: "name", sortable: true },
    {
      title: "TOTAL GIFT",
      data: "subtotal",
      render: (data) => {
        return `$ ${data ? data : 0}`;
      },
    },
    {
      title: "Total Amount",
      data: "totalAmount",
      render: (data) => {
        return `$ ${data}`;
      },
    },
    { title: "Total Quantity", data: "totalQuantity", sortable: true },
    {
      title: "Status",
      data: "status",
      render: (data) => {
        if (data) {
          switch (data) {
            case 1:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-wisteria">open</span>`;
            case 2:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-nileBlue">in progress</span>`;
            case 3:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-radicalRed">canceled</span>`;
            case 4:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-shamrock">completed</span>`;
            case 5:
              return `<span style="width: 100px" class="badge badge-pill text-white bg-warning">On hold</span>`;
            default:
              return "Error";
          }
        }
      },
    },
  ];
  const prepareDetails = (row) => {
    setOrderDetail(row.data());
    toggleDrawer();
  };
  const toggleClose = () => {
    toggleModalHistory(); 
    setSkuName(''); 
    setDataTableData({
      purchaseOrderResponse: [],
    })
  }

  const getHistoryBySKU = () => {
    if (inputSearch.length > 0) {
      purchaserCtl.getHistoryBySKU(inputSearch, (data) => {
        if (data && !data.error) {
          setDataTableData(data);
          setSkuName(inputSearch);
          setInputSearch("");
        } else if (data.errorMessage) {
          Notify(alert, "danger", data.errorMessage);
        } else {
          Notify(alert, "danger", data.error);
        }
      });
    } else {
      Notify(alert, "danger", "Please enter SKU");
    }
  };

  useEffect(() => {
    dataTableRef.current &&
      dataTableRef.current.dataTable
        .clear()
        .rows.add(dataTableData.purchaseOrderResponse)
        .draw();
  }, [dataTableData]);
  return (
    <>
      <NotificationAlert ref={alert} />
      <Modal isOpen={modalHistory} toggle={toggleClose} size="xl">
        <ModalHeader toggle={toggleClose} className="bg-info">
          History by SKU: <b>{skuName}</b>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col
              md="12"
              className=" justify-content-center align-items-end d-flex"
            >
              <FormGroup>
                <Label for="mainPhone">SKU:</Label>
                <Input
                  type="text"
                  style={{ maxWidth: 400, height: 38 }}
                  value={inputSearch}
                  onChange={(e) => setInputSearch(e.target.value)}
                />
              </FormGroup>
              <Button
                initial={{ x: "-500%", opacity: 0 }}
                animate={{
                  x: 0,
                  opacity: 1,
                  transition: { delay: 0.4, duration: 0.5 },
                }}
                color="primary"
                onClick={getHistoryBySKU}
              >
                <i className="fas fa-search" /> Search
              </Button>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <h4 >{dataTableData.stock ? `Stock: ${dataTableData.stock}` : `Stock: ${0}`}</h4>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <DataTable
                ref={dataTableRef}
                data={null}
                columns={header}
                options={{ dom: "tip", order: [[0, 'desc']] }}
                addCustomButtons={[
                  {
                    callback: prepareDetails,
                    name: "purchaserDetails",
                    icon: "fas fa-info-circle",
                    style:
                      "padding: 5px 10px; background: transparent; font-size: 1.2rem",
                    props:
                      'data-toggle="tooltip" data-placement="top" title="See more details"',
                  },
                ]}
              />
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter className="flex-nowrap">
          <Col md={6} className="justify-content-end text-right">
            <Button
              type="submit"
              className="mr-3"
              color="secondary"
              onClick={toggleClose}
            >
              Close
            </Button>
          </Col>
        </ModalFooter>
      </Modal>
      <SwipeableDrawer
        anchor="right"
        open={openDrawer}
        onClose={toggleDrawer}
        onOpen={toggleDrawer}
      >
        <div style={{ width: "70vw" }}>
          <HistorySKUDetails data={orderDetail} />
        </div>
      </SwipeableDrawer>
    </>
  );
};

export default ModalHistorySKU;
